<template>
    <span v-show="isShowPage">
      <v-row align="center" justify="center">
        <v-col cols="3">
          <v-text-field
            append-icon="mdi-magnify"
            outlined
            solo
            hide-details
            v-model="search"
            class="search"
            placeholder="Search..."
            v-on:keyup.enter="getDataTable()"
            color="#2671D9"
          >
          </v-text-field>
        </v-col>
        <v-col>
          <v-btn
            class="ma-2"
            depressed
            outlined
            color="#2671D9"
            @click="openDialog()"
          >
            <v-icon left color="#2671D9">
              $ic-filter
            </v-icon>
            Filter
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn
            class="ma-2"
            depressed
            outlined
            color="#2671D9"
          >
            <v-icon left color="#2671D9">
              $ic-export-excel
            </v-icon>
            Export Excel
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <Table :headers="headers" :items="items" @onChangePage="getDataTable" @sortOptions="updateSortDatatable" :defaultSize="5" :loading="isFetching">
            <!-- <template slot="action" slot-scope="data">
              <v-btn class="mx-1 ic-view" fab x-small></v-btn>
              <v-btn class="mx-1 ic-edit" fab x-small @click="openDialogForm('edit', data.item)"></v-btn>
            </template> -->
          </Table>
        </v-col>
      </v-row>
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <span>Filter Data</span>
              </v-col>
              <v-col class="text-right">
                <v-btn
                  icon
                  x-small
                  @click="dialog = false"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">Charger</div>
                  <v-autocomplete
                    v-model="filter.charger"
                    :items="filterOptions.charger"
                    label="Semua Charger"
                    dense
                    solo
                    flat
                    outlined
                    item-text="text"
                    item-value="id"
                    return-object
                    cache-items
                    :color="colorActive"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="pb-0 pt-1">
                  <div class="label-custom mb-2" :style="'color:' + colorActive">Status</div>
                  <v-autocomplete
                    v-model="filter.status"
                    :items="filterOptions.status"
                    label="Semua Status"
                    dense
                    solo
                    flat
                    outlined
                    item-text="text"
                    item-value="id"
                    return-object
                    cache-items
                    :color="colorActive"
                    clearable
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              small
              depressed
              color="#999999"
              text
              @click="dialog = false"
            >
              Kembali
            </v-btn>
            <v-btn
              small
              depressed
              :color="colorActive"
              @click="dialog = false; getDataTable()"
              dark
            >
              Cari
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </span>
  </template>
<script>
import Table from '../../components/Table.vue'
import UserManagementService from '@/services/default/UserManagementService'
import alert from '@/commons/helper/alert.helper'

const userManagementService = UserManagementService.build()
export default {
  name: 'spklu-monitoring-spklu',
  components: {
    Table
  },
  data: () => ({
    colorActive: '#2671D9',
    colorInactive: '#9A9A9A',
    headers: [
      { value: 'number', text: 'No.', sortable: false, align: 'center' },
      { value: 'fullName', text: 'Lokasi SPKLU', align: 'center' },
      { value: 'username', text: 'Charger', align: 'center' },
      { value: 'waktu', text: 'Waktu Transaksi', align: 'center' },
      { value: 'kwh', text: 'kWh', align: 'center' },
      { value: 'total', text: 'Total', align: 'center', sortable: false }
    ],
    items: {},
    search: '',
    sortSettings: '',
    isShowPage: true,
    isFetching: false,
    timer: '',
    dialog: false,
    filterOptions: {
      charger: [
        // { id: 'ADMIN', text: 'Admin' }
      ],
      status: []
    },
    filter: {}
  }),
  async created () {
    // delete localStorage
    localStorage.removeItem('tableQuery')
  },
  computed: {},
  mounted: function () {
    this.$nextTick(() => {
      // re-get data every 1 minute
      this.timer = setInterval(() => {
        const tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        if (tableQuery) {
          this.getDataTable(tableQuery.page, tableQuery.size)
        } else {
          this.getDataTable()
        }
      }, 60000)
    })
  },
  destroyed: function () {
    // kill re-get data every 1 minute
    clearInterval(this.timer)
  },
  watch: {
    search: function (val) {
      if (val === '') {
        this.getDataTable()
      }
    }
  },
  methods: {
    openDialog () {
      this.dialog = true
    },
    async resetData () {
      this.items = {}
      // this.search = ''
      this.sortSettings = ''
    },
    async getDataTable (page, size) {
      this.isFetching = true
      this.paging.page = page
      this.paging.size = size

      let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      localStorage.setItem('tableQuery', JSON.stringify({
        page: page,
        size: size,
        sort_by: tableQuery ? tableQuery.sort_by : ''
      }))

      // re-get data after set
      tableQuery = JSON.parse(localStorage.getItem('tableQuery'))

      const param = Object.assign({
        keyword: this.search,
        sort: tableQuery ? tableQuery.sort_by : ''
      }, this.paging)

      const response = await userManagementService.getPgb(param)
      if (response.data.success === true) {
        const { data: { data: { content, totalPages, number, size, totalElements } } } = response
        this.items = Object.assign({
          data: content,
          total: totalPages,
          size,
          page: number + 1,
          totalElements
        })
      } else {
        alert.failed(response.data.status + ' - ' + response.data.message)
      }
      this.isFetching = false
    },
    async updateSortDatatable (options) {
      if (options.sortBy) {
        this.sortSettings = ''
        for (let i = 0; i < options.sortBy.length; i++) {
          const sort = options.sortDesc[i] === false ? 'asc' : 'desc'
          let column = ''

          if (options.sortBy[i] === 'fullName') {
            column = 'fullName'
          } else if (options.sortBy[i] === 'username') {
            column = 'username'
          } else if (options.sortBy[i] === 'waktu') {
            column = 'waktu'
          } else if (options.sortBy[i] === 'kwh') {
            column = 'kwh'
          } else if (options.sortBy[i] === 'total') {
            column = 'total'
          }

          if (i === 0) {
            this.sortSettings += column + ',' + sort
          } else {
            this.sortSettings += '&sort=' + column + ',' + sort
          }
        }

        let tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        localStorage.setItem('tableQuery', JSON.stringify({
          page: tableQuery ? tableQuery.page : 0,
          size: tableQuery ? tableQuery.size : 20,
          sort_by: this.sortSettings
        }))
        tableQuery = JSON.parse(localStorage.getItem('tableQuery'))
        this.getDataTable(tableQuery.page, tableQuery.size)
      }
    },
    exportExcel () {}
  }
}
</script>
  <style scoped>
    .search {
      height: 48px;
    }
  </style>
